import { Tech } from 'generated/apolloComponents'
import { hexToRGB } from '@/helpers/utils'

interface IProps {
  item: Tech
  color: string
}

const TechIcon = ({ item, color }: IProps) => (
  <div className='flex items-center flex-col mb-5 w-20 mr-3'>
    {item.icon?.url && (
      <div
        className='circle-icon'
        style={{
          background: `linear-gradient(45deg, ${hexToRGB(
            color,
            0.7
          )}, ${hexToRGB(color, 1)})`,
        }}
      >
        <img
          src={item.icon.url}
          className='mx-auto object-contain object-center brightness-[0%] invert'
          style={{ maxHeight: '100%', maxWidth: '100%' }}
          width={40}
          height={40}
          alt={item.name as string}
        />
      </div>
    )}
    <span className='text-xs font-light text-gray-300 text-center mt-1 leading-none'>
      {item.name}
    </span>
  </div>
)

export default TechIcon
